import React from 'react';
import { withTranslation } from '../ChildrenContext.js';
import PropTypes from 'prop-types';
import DataComponentTable from './DataComponent__Table';
import DataComponentTile from './DataComponent__Tile';

const DataComponentBody = ({
    displayControl,
    data,
    headerNames,
    headerNamesArray,
    multiLevelHeaderNames,
    columnData,
    loading,
    settings,
    settingKey,
    filters,
    className
}) => {
    const getRenderComponent = () => {
        const dataItem = displayControl.data.find(item => item.type === displayControl.type);
        const Component = dataItem.component;

        if (React.isValidElement(Component)) {
            return Component;
        } else {
            return (
                <Component
                    data={data}
                />
            );
        }
    };

    const renderTable = () => {
        return (
            <DataComponentTable
                data={data}
                headerNames={headerNames}
                multiLevelHeaderNames={multiLevelHeaderNames}
                columnData={columnData}
                loading={loading}
                settings={settings}
                settingKey={settingKey}
                filters={filters}
                className={className}
            />
        );
    };

    const renderTile = () => {
        return (
            <DataComponentTile
                data={data}
                headerNames={headerNames}
                headerNamesArray={headerNamesArray}
                multiLevelHeaderNames={multiLevelHeaderNames}
                columnData={columnData}
                loading={loading}
                settings={settings}
                settingKey={settingKey}
                filters={filters}
                className={className}
            />
        );
    };

    const hasData = data && (
        (Array.isArray(data) && data.length > 0) ||
        (typeof data === 'object' && !Array.isArray(data) && Object.keys(data).length > 0)
    );

    if (!displayControl || !displayControl.type || displayControl.type === 'table' || !hasData) {
        return renderTable();
    }

    if (displayControl.type === 'tile' && hasData) {
        return renderTile();
    }

    return getRenderComponent();
};

DataComponentBody.propTypes = {
    displayControl: PropTypes.object,
    data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    headerNames: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    headerNamesArray: PropTypes.bool,
    multiLevelHeaderNames: PropTypes.array,
    columnData: PropTypes.object,
    loading: PropTypes.bool,
    settings: PropTypes.bool,
    settingKey: PropTypes.string,
    filters: PropTypes.object,
    className: PropTypes.string
};

export default withTranslation(DataComponentBody);
